import { IGetAllAssistenciaArquivoDiversoUseCase } from "../../../presentation/useCases/read/get_all_assistencia_arquivo_diverso_use_case";
import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { AssistenciaTecnicaArquivoLista } from "../../models/assistencia_tecnica_arquivo_lista";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";

/**
 * GetAllAssistenciaArquivoDiversoUseCase
 */

export class GetAllAssistenciaArquivoDiversoUseCase
  extends BasePaginatedUseCase<AssistenciaTecnicaArquivoLista>
  implements IGetAllAssistenciaArquivoDiversoUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) {
    super();
  }

  async getAllAssistenciaArquivoDiverso(
    idAssistenciaTecnica: number | null,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {
    if (idAssistenciaTecnica === null) {
      throw new Error('ID da assistência técnica é obrigatório para buscar os arquivos diversos!');
    }

    const result = await this.repository.getAllAssistenciaArquivoDiverso(
      idAssistenciaTecnica,
      page,
      rowsPerPage,
    );

    this._items = result.items;
    this._totalItems = result.totalItems;
    this._currentPage = result.currentPage;
    this._pageSize = result.pageSize;
  }
}
